import React from 'react';
import { Tour } from 'antd';
import styles from './index.modules.scss';

export const ShakkerTour = (props) => {
  const { open, steps, onClose, arrow = false, ...restProps } = props;
  return (
    <Tour
      steps={steps}
      open={open}
      width={280}
      arrow={arrow}
      disabledInteraction={true}
      indicatorsRender={(current, total) => (
        <span className="text-[#fff]">
          {current + 1}/{total}
        </span>
      )}
      rootClassName={`${styles.shakkerTourWrapper} shakker-tour-wrapper`}
      onClose={onClose}
      {...restProps}
    />
  );
};
